import { useRef, useCallback } from 'react';

/**
 * Hook to play notification sound when new notifications arrive
 */
export const useNotificationSound = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const playSound = useCallback(() => {
    try {
      if (!audioRef.current) {
        audioRef.current = new Audio('/sounds/notification.mp3');
        audioRef.current.volume = 0.5;
      }
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch((err) => {
        // Ignore autoplay restrictions - browser may block until user interaction
        console.debug('Notification sound blocked by browser:', err.message);
      });
    } catch (error) {
      console.warn('Could not play notification sound:', error);
    }
  }, []);

  return { playSound };
};

export default useNotificationSound;
